import React, { useEffect, useState } from 'react';
import { FormikProps } from 'formik';
import { CustomField } from '../../../commonTypes/organization.types';
import { ISettingsValues } from '../../../views/Settings';
import { Button, Input } from '../../Common';
import { Label } from '../../Common/Label';
import { useTranslation } from '../../../hooks/useTranslation';

interface IEditOrganizationCustomFields {
    customFields: CustomField[];
    context: FormikProps<ISettingsValues>;
    close: () => void;
    setCustomFields: any;
}

const EditOrganizationCustomFields = ({ customFields, context, close, setCustomFields }: IEditOrganizationCustomFields) => {
    const { t } = useTranslation();
    const { setFieldValue } = context;
    const [modalValues, setModalValues] = useState(customFields);
    const [initialLabels, setInitialLabels] = useState<{ [key: string]: string }>({});

    const handleRemoveField = (fieldName: string) => {
        const updatedFields = modalValues.filter(field => field.name !== fieldName);
        setModalValues(updatedFields);
    };

    useEffect(() => {
        const initialLabelsMap: { [key: string]: string } = {};
        customFields.forEach(field => {
            initialLabelsMap[field.name] = field.label;
        });
        setInitialLabels(initialLabelsMap);
    }, [customFields]);

    const handleChange = (fieldName: string, value: string) => {
        const updatedCustomFields = modalValues.map(field => {
            if (field.name === fieldName) {
                return { ...field, label: value };
            }
            return field;
        });

        setModalValues(updatedCustomFields);
    };

    const cancelAction = () => {
        setModalValues(customFields);
        close();
    };

    const updateCustomFields = () => {
        const updatedModalValues = modalValues.map(field => ({
            ...field,
            name: field.label,
        }));
        setCustomFields(updatedModalValues);
        setFieldValue('customFields', updatedModalValues);
        close();
    };

    return (
        <div className="edit-organization-custom-fields">
            <h3 className="edit-organization-custom-fields__title">{t('settings.editCustom')}</h3>
            <div className="edit-organization-custom-fields__content">
                {!!modalValues?.length &&
                    modalValues.map((field: CustomField) => (
                        <div key={field.name} className="edit-organization-custom-fields__content--item">
                            <div className="edit-organization-custom-fields__content--item--label">
                                <Label label={initialLabels[field.name]} />
                                <img src="/svg/trash-can.svg" alt="trash can" onClick={() => handleRemoveField(field.name)} />
                            </div>
                            <Input
                                key={field.name}
                                id={field.name}
                                value={field.label}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(field.name, e.target.value)}
                            />
                        </div>
                    ))}
            </div>
            <div className="edit-organization-custom-fields__buttons">
                <Button text={t('common.cancel')} variant="text" onClick={() => cancelAction()} color="blue" />
                <Button text={t('settings.saveChanges')} variant="contained" onClick={() => updateCustomFields()} />
            </div>
        </div>
    );
};

export default EditOrganizationCustomFields;
